export type DashboardLayoutVariant = 'v2' | 'v3';

const STORAGE_KEY = 'oneDrawDashboardLayoutVariant';

export function readDashboardLayoutVariant(): DashboardLayoutVariant {
    try {
        if (typeof window === 'undefined') return 'v2';
        return sessionStorage.getItem(STORAGE_KEY) === 'v3' ? 'v3' : 'v2';
    } catch {
        return 'v2';
    }
}

export function persistDashboardLayoutVariant(variant: DashboardLayoutVariant): void {
    try {
        sessionStorage.setItem(STORAGE_KEY, variant);
    } catch {
        /* ignore */
    }
}
